// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Place your extensions here to make migration to a new release easier. */
/*i.pi.pi-circle-on{
	font-size: 10px !important;
}*/

.documents-dialog {
	width: 50%;
}
.documents-dialog .p-dialog-content {
	border: 0px !important;
	border-radius: 0px !important;

}
.documents-dialog .p-dialog-titlebar {
	background-color: #5CB85C !important;
	border:0 !important;
	text-align: center;
	color: #ffffff !important;
}

.documents-dialog .dialog-sign-in {
	font-size: 40px;
	color: #10497F;
	font-weight: 700;
	margin-top: 3rem;
	margin-bottom: 3rem;
}

.documents-dialog .p-inputgroup {
	justify-content: center;
	/*width: 70%;*/
	margin: auto;
}

.documents-dialog .p-inputtext:hover {
	border: 1px solid #a6a6a6 !important;
	/*border-left:0 !important;*/
}

.documents-dialog .p-inputtext.p-component {
	width: 100%;
	outline: none;
	background-color: #eaeaea;
}

.documents-dialog .p-button {
	padding: 0px 20px !important;
	margin-top: 20px !important;
	margin-right: 10px !important;
	font-size: 20px !important;
}

.documents-dialog .p-inputgroup.error {
	border: 1px solid red;
	border-radius: 3px;
}


.documents-dialog .default-btn:focus {
	/*box-shadow: none !important;*/
}
.documents-dialog .default-btn:hover {
	box-shadow: 0 0 0 0.2em #8dcdff !important;
}

.documents-dialog .p-dialog-titlebar-icons {
	top: 10px;
	position: absolute;
	right: 10px;
}

.documents-dialog .textAlignLeft {
	margin-left: 2em;
	margin-right: 2em;
	text-align: left;
}

#role {
	width: 70% !important;
}

ul.p-submenu-list.p-submenu-list ul.p-submenu-list {
		width: 20em !important;
}

ul.p-submenu-list.p-submenu-list {
		width: 15em !important;
}

body .p-datatable .p-datatable-tbody > tr.p-highlight-a {
	background-color: rgba(199, 156, 212, 0.17);
	color: #000000;
}

body .p-datatable .p-datatable-tbody > tr.p-highlight-b {
	background-color: rgba(156, 209, 212, 0.16);
	color: #000000;
}

#Deposit-form input, #Payment-form input, #Payment-form .p-dropdown {
	margin-top: 15px;
}

.p-float-label label {
	font-weight: normal;
	position: absolute;
	pointer-events: none;
	left: .5em;
	top: 50%;
	margin-top: -.05em;
	transition: .3s ease all;
	-moz-transition: .3s ease all;
	-webkit-transition: .3s ease all;
	color: #898989;
	line-height: 1;
}
.p-float-label input.p-filled ~ label {
	top: 0.25em;
	color: #000000;
}

body .p-inputtext:enabled:focus {
	box-shadow: none;
}

.transaction-table {
	width: 80%;
	max-width: inherit;
	top: 50%;
}

.case-notes {
	width: 80%;
	max-width: inherit;;
	top:50%;
}
.case-notes #casenote {
		width: 400px;
		height: 75px !important;
		min-height: 30px;
}

button.p-button.p-component.export-button.p-button-text-icon-left {
  margin: 0 !important;
  padding: 0px 10px !important;
  font-size: 14px !important;
}

.client-details, .client-summary-dialog {
	width: 50%;
	max-width: inherit;
	top: 50%;
}

.client-summary-dialog .p-dialog-titlebar {
	background-color: #10497F !important;
}

.transactions-context-menu {
	z-index: 3001 !important;
}

.card-w-title.transaction {
	padding-bottom: 0em !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,0EAA0E;AAC1E;;EAEE;;AAEF;CACC,UAAU;AACX;AACA;CACC,sBAAsB;CACtB,6BAA6B;;AAE9B;AACA;CACC,oCAAoC;CACpC,mBAAmB;CACnB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,uBAAuB;CACvB,cAAc;CACd,YAAY;AACb;;AAEA;CACC,oCAAoC;CACpC,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,aAAa;CACb,yBAAyB;AAC1B;;AAEA;CACC,4BAA4B;CAC5B,2BAA2B;CAC3B,6BAA6B;CAC7B,0BAA0B;AAC3B;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;;;AAGA;CACC,+BAA+B;AAChC;AACA;CACC,0CAA0C;AAC3C;;AAEA;CACC,SAAS;CACT,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,oBAAoB;CACpB,UAAU;CACV,QAAQ;CACR,kBAAkB;CAClB,wBAAwB;CACxB,6BAA6B;CAC7B,gCAAgC;CAChC,cAAc;CACd,cAAc;AACf;AACA;CACC,WAAW;CACX,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,OAAO;AACR;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;CACC,UAAU;CACV,kBAAkB;CAClB,QAAQ;AACT;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,8BAA8B;AAC/B","sourcesContent":["/* Place your extensions here to make migration to a new release easier. */\n/*i.pi.pi-circle-on{\n\tfont-size: 10px !important;\n}*/\n\n.documents-dialog {\n\twidth: 50%;\n}\n.documents-dialog .p-dialog-content {\n\tborder: 0px !important;\n\tborder-radius: 0px !important;\n\n}\n.documents-dialog .p-dialog-titlebar {\n\tbackground-color: #5CB85C !important;\n\tborder:0 !important;\n\ttext-align: center;\n\tcolor: #ffffff !important;\n}\n\n.documents-dialog .dialog-sign-in {\n\tfont-size: 40px;\n\tcolor: #10497F;\n\tfont-weight: 700;\n\tmargin-top: 3rem;\n\tmargin-bottom: 3rem;\n}\n\n.documents-dialog .p-inputgroup {\n\tjustify-content: center;\n\t/*width: 70%;*/\n\tmargin: auto;\n}\n\n.documents-dialog .p-inputtext:hover {\n\tborder: 1px solid #a6a6a6 !important;\n\t/*border-left:0 !important;*/\n}\n\n.documents-dialog .p-inputtext.p-component {\n\twidth: 100%;\n\toutline: none;\n\tbackground-color: #eaeaea;\n}\n\n.documents-dialog .p-button {\n\tpadding: 0px 20px !important;\n\tmargin-top: 20px !important;\n\tmargin-right: 10px !important;\n\tfont-size: 20px !important;\n}\n\n.documents-dialog .p-inputgroup.error {\n\tborder: 1px solid red;\n\tborder-radius: 3px;\n}\n\n\n.documents-dialog .default-btn:focus {\n\t/*box-shadow: none !important;*/\n}\n.documents-dialog .default-btn:hover {\n\tbox-shadow: 0 0 0 0.2em #8dcdff !important;\n}\n\n.documents-dialog .p-dialog-titlebar-icons {\n\ttop: 10px;\n\tposition: absolute;\n\tright: 10px;\n}\n\n.documents-dialog .textAlignLeft {\n\tmargin-left: 2em;\n\tmargin-right: 2em;\n\ttext-align: left;\n}\n\n#role {\n\twidth: 70% !important;\n}\n\nul.p-submenu-list.p-submenu-list ul.p-submenu-list {\n\t\twidth: 20em !important;\n}\n\nul.p-submenu-list.p-submenu-list {\n\t\twidth: 15em !important;\n}\n\nbody .p-datatable .p-datatable-tbody > tr.p-highlight-a {\n\tbackground-color: rgba(199, 156, 212, 0.17);\n\tcolor: #000000;\n}\n\nbody .p-datatable .p-datatable-tbody > tr.p-highlight-b {\n\tbackground-color: rgba(156, 209, 212, 0.16);\n\tcolor: #000000;\n}\n\n#Deposit-form input, #Payment-form input, #Payment-form .p-dropdown {\n\tmargin-top: 15px;\n}\n\n.p-float-label label {\n\tfont-weight: normal;\n\tposition: absolute;\n\tpointer-events: none;\n\tleft: .5em;\n\ttop: 50%;\n\tmargin-top: -.05em;\n\ttransition: .3s ease all;\n\t-moz-transition: .3s ease all;\n\t-webkit-transition: .3s ease all;\n\tcolor: #898989;\n\tline-height: 1;\n}\n.p-float-label input.p-filled ~ label {\n\ttop: 0.25em;\n\tcolor: #000000;\n}\n\nbody .p-inputtext:enabled:focus {\n\tbox-shadow: none;\n}\n\n.transaction-table {\n\twidth: 80%;\n\tmax-width: inherit;\n\ttop: 50%;\n}\n\n.case-notes {\n\twidth: 80%;\n\tmax-width: inherit;;\n\ttop:50%;\n}\n.case-notes #casenote {\n\t\twidth: 400px;\n\t\theight: 75px !important;\n\t\tmin-height: 30px;\n}\n\nbutton.p-button.p-component.export-button.p-button-text-icon-left {\n  margin: 0 !important;\n  padding: 0px 10px !important;\n  font-size: 14px !important;\n}\n\n.client-details, .client-summary-dialog {\n\twidth: 50%;\n\tmax-width: inherit;\n\ttop: 50%;\n}\n\n.client-summary-dialog .p-dialog-titlebar {\n\tbackground-color: #10497F !important;\n}\n\n.transactions-context-menu {\n\tz-index: 3001 !important;\n}\n\n.card-w-title.transaction {\n\tpadding-bottom: 0em !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
